module.exports = __webpack_public_path__ + "static/media/awale.8e575eac.jpg";